export function filterRecordOnKey<T>(record: Record<string, T>, filter?: string) {
  return Object.fromEntries(
    Object.entries(record).filter(
      ([key]) => !filter || key.toLowerCase().includes(filter.toLowerCase()),
    ),
  );
}
